module.exports = __webpack_public_path__ + "img/logo.ef2514b0.png";